import React, { useState } from 'react';

import {
	FormControl,
	FormLabel,
	RadioGroup,
	FormControlLabel,
	Radio,
	FormHelperText,
} from '@mui/material';

import { IQuestionnaireFormWidgetProps } from 'src/features/questionnaire/domain/types';

const RadioButtonWidget: React.FC<IQuestionnaireFormWidgetProps> = ({
	question,
	onValueChange,
	isDisabled,
	error,
	helperText = 'This field is invalid',
}) => {
	const value =
		question.submitted_data?.value_single_select?.value.toString() ?? '';

	const [selectedRadioValue, setSelectedRadioValue] = useState(value);

	const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setSelectedRadioValue(value);
		const formatedValue = { value: value };
		onValueChange(question, formatedValue, 'value_single_select');
	};

	return (
		<FormControl
			component='fieldset'
			required={question.is_required}
			disabled={isDisabled}
			error={error}
			sx={{ width: '100%', textAlign: 'left' }}
		>
			<FormLabel component='legend'>{question.text}</FormLabel>
			<RadioGroup value={selectedRadioValue} onChange={handleRadioChange}>
				{question.options.map((option) => (
					<FormControlLabel
						key={option.id}
						value={option.id.toString()}
						control={<Radio />}
						label={option.value}
						sx={{ marginLeft: 0 }}
					/>
				))}
			</RadioGroup>
			{error && <FormHelperText>{helperText}</FormHelperText>}
		</FormControl>
	);
};

export default RadioButtonWidget;
